import { render, staticRenderFns } from "./UserMescanDataStatistics.vue?vue&type=template&id=31a71cd1&scoped=true"
import script from "./UserMescanDataStatistics.vue?vue&type=script&lang=js"
export * from "./UserMescanDataStatistics.vue?vue&type=script&lang=js"
import style0 from "./UserMescanDataStatistics.vue?vue&type=style&index=0&id=31a71cd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a71cd1",
  null
  
)

export default component.exports